module.exports = {
  emptyMessage: 'الرجاء إدخال تاريخ انتهاء صلاحية البطاقة',
  expiredMessage: 'عفواً! انتهت صلاحية البطاقة التي أدخلتها.',
  defaultMessage: 'تاريخ انتهاء الصلاحية غير صالح',
};
